import PropTypes from 'prop-types';
import styled from 'styled-components';
import Type from "../Type";
var TypeListItem = styled(Type.li).withConfig({
  displayName: "TypeListItem",
  componentId: "sc-1ayptgd-0"
})(["display:list-item;padding-bottom:", ";"], function (props) {
  return !props.condensed && '1em';
});
TypeListItem.propTypes = {
  condensed: PropTypes.bool
};
export default TypeListItem;